/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";
import * as XLSX from "xlsx";

// --- Renk sabitleri (proje genelindeki dark-theme paleti) ---
const C = {
    bullish: "#16a34a",
    bearish: "#dc2626",
    bg:      "#0f172a",
    panel:   "#1e293b",
    border:  "#334155",
    text:    "#e2e8f0",
    muted:   "#94a3b8",
    accent:  "#3b82f6",
    warning: "#f59e0b",
    gold:    "#eab308",
};

const ETIKET_RENK = {
    "Pozitif": C.bullish,
    "Negatif": C.bearish,
    "Notr":    C.muted,
    "Nötr":    C.muted,
};
const etiketRenk = (e) => ETIKET_RENK[e] || C.muted;

// --- Bilgi İçerikleri ---
const BILGI_ICERIK = {
    "Genel Piyasa Haber Skoru": {
        baslik: "Genel Piyasa Haber Skoru",
        icerik: "Son 7 günde toplanan tüm haberlerin (BIST100/30 veya Kripto genelinde) kural-tabanlı sözlük + Gemini AI teyidiyle hesaplanan skorlarının ağırlıklı ortalamasıdır. -100 ile +100 arasında değişir; 15 üzeri Pozitif, -15 altı Negatif, arası Nötr olarak sınıflandırılır. Piyasanın genel haber akışının yönünü özetler.",
    },
    "Ortalama Skor": {
        baslik: "Ortalama Skor",
        icerik: "İlgili sembol için o gün toplanan tüm haberlerin duygu skorlarının ortalamasıdır (-100..+100). Her haberin skoru kural-tabanlı sözlük analizi ile hesaplanır, belirsiz durumlarda Gemini AI teyidi devreye girer.",
    },
    "En Güçlü Skor": {
        baslik: "En Güçlü Skor",
        icerik: "İlgili sembol için o gün toplanan haberler arasında mutlak değeri en yüksek (en güçlü pozitif veya en güçlü negatif) tekil haber skorudur. Ortalamayı yumuşatan haberlerin arasında öne çıkan en etkili haberi gösterir.",
    },
    "Etiket": {
        baslik: "Etiket",
        icerik: "Ortalama Skor'a göre atanan kategori: Pozitif (skor > 15), Negatif (skor < -15) veya Nötr (-15 ile 15 arası). Tablodaki ve genel piyasa kartındaki renklendirme bu etikete göre yapılır.",
    },
};

function BilgiIkonu({ alan }) {
    const [acik, setAcik] = useState(false);
    const bilgi = BILGI_ICERIK[alan];
    if (!bilgi) return null;
    return (
        <span style={{ position: "relative", display: "inline-flex", alignItems: "center", marginLeft: 4 }}>
            <span
                onMouseEnter={() => setAcik(true)}
                onMouseLeave={() => setAcik(false)}
                style={{ cursor: "help", color: C.muted, fontSize: 11,
                    border: `1px solid ${C.border}`, borderRadius: "50%",
                    width: 14, height: 14, display: "inline-flex", alignItems: "center",
                    justifyContent: "center", fontWeight: 700, lineHeight: 1 }}>
                i
            </span>
            {acik && (
                <div style={{
                    position: "absolute", top: "calc(100% + 6px)", left: "50%",
                    transform: "translateX(-50%)", zIndex: 500,
                    background: C.panel, border: `1px solid ${C.border}`,
                    borderRadius: 10, padding: "12px 14px", width: 270,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.5)", pointerEvents: "none",
                }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: C.accent, marginBottom: 6 }}>{bilgi.baslik}</div>
                    <div style={{ fontSize: 11, color: C.muted, lineHeight: 1.6, whiteSpace: "pre-line" }}>{bilgi.icerik}</div>
                </div>
            )}
        </span>
    );
}

// --- Yardımcı: token al (expiry kontrolü dahil) ---
async function getToken() {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return null;
    if (session.expires_at * 1000 - Date.now() < 5 * 60 * 1000) {
        const { data } = await supabase.auth.refreshSession();
        return data.session?.access_token;
    }
    return session.access_token;
}

const formatSure = (sn) => sn >= 60 ? `${Math.floor(sn / 60)}dk ${sn % 60}sn` : `${sn}sn`;

// --- Skor Çubuğu (-100..+100, ortadan başlayan çift yönlü bar) ---
function SkorCubugu({ skor }) {
    const renk = skor > 15 ? C.bullish : skor < -15 ? C.bearish : C.muted;
    const genislik = Math.min(100, Math.abs(skor));
    return (
        <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 130 }}>
            <div style={{ flex: 1, height: 8, background: "#0a0f1e", borderRadius: 4, overflow: "hidden",
                border: `1px solid ${C.border}`, position: "relative" }}>
                <div style={{
                    position: "absolute", top: 0, bottom: 0,
                    left: skor >= 0 ? "50%" : `${50 - genislik / 2}%`,
                    width: `${genislik / 2}%`,
                    background: renk, borderRadius: 2,
                }} />
                <div style={{ position: "absolute", left: "50%", top: 0, bottom: 0, width: 1, background: C.border }} />
            </div>
            <span style={{ fontSize: 12, fontWeight: 700, color: renk, minWidth: 38, textAlign: "right" }}>
                {skor > 0 ? "+" : ""}{skor}
            </span>
        </div>
    );
}

// --- İndir Alt Menüsü ---
function IndirMenusu({ veriler, setIslemMenuAcik }) {
    const [acik, setAcik] = useState(false);
    const dosyaAdi = `haber_duygu_${new Date().toLocaleDateString("tr-TR").replace(/\./g, "-")}`;
    const indir = async (fmt) => {
        setAcik(false); setIslemMenuAcik(false);
        const veri = veriler();
        if (!veri?.length) return;
        if (fmt === "xlsx") {
            const ws = XLSX.utils.json_to_sheet(veri);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Haber Duygu Analizi");
            XLSX.writeFile(wb, `${dosyaAdi}.xlsx`);
        } else if (fmt === "csv") {
            const h = Object.keys(veri[0] || {});
            const rows = veri.map(r => h.map(k => { const v = String(r[k] ?? ""); return v.includes(",") || v.includes('"') ? `"${v.replace(/"/g, '""')}"` : v; }).join(","));
            const blob = new Blob(["\uFEFF" + [h.join(","), ...rows].join("\n")], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a"); a.href = url; a.download = `${dosyaAdi}.csv`; a.click(); URL.revokeObjectURL(url);
        } else if (fmt === "pdf") {
            try {
                const { default: jsPDF } = await import("jspdf");
                const { default: autoTable } = await import("jspdf-autotable");
                const h = Object.keys(veri[0] || {});
                const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
                doc.setFontSize(14); doc.text("Haber Duygu Analizi Sonuçları", 20, 30);
                doc.setFontSize(9); doc.setTextColor(100);
                doc.text(`${veri.length} kayıt · ${new Date().toLocaleDateString("tr-TR")}`, 20, 48);
                autoTable(doc, { head: [h], body: veri.map(r => h.map(k => String(r[k] ?? ""))), startY: 58,
                    styles: { fontSize: 7, cellPadding: 3 },
                    headStyles: { fillColor: [29, 78, 216], textColor: 255, fontStyle: "bold" },
                    alternateRowStyles: { fillColor: [245, 247, 250] } });
                doc.save(`${dosyaAdi}.pdf`);
            } catch { toast.error("PDF oluşturulamadı"); indir("svg"); }
        } else if (fmt === "svg") {
            const h = Object.keys(veri[0] || {});
            const cw = Math.max(60, Math.floor(740 / h.length)), rh = 18, hh = 24, tw = cw * h.length;
            const pw = Math.max(tw + 40, 800), ph = 80 + hh + veri.length * rh;
            const esc = s => String(s).slice(0, 18).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            const rows = veri.map((r, i) => `<g transform="translate(20,${60 + hh + i * rh})"><rect width="${tw}" height="${rh}" fill="${i % 2 === 0 ? "#1e293b" : "#0f172a"}" stroke="#334155" stroke-width="0.5"/>${h.map((k, j) => `<text x="${j * cw + 4}" y="13" font-size="9" fill="#e2e8f0" font-family="Arial">${esc(r[k])}</text>`).join("")}</g>`).join("");
            const heads = h.map((k, j) => `<text x="${20 + j * cw + 4}" y="48" font-size="9" font-weight="bold" fill="white" font-family="Arial">${esc(k)}</text>`).join("");
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${pw}" height="${ph}"><rect width="${pw}" height="${ph}" fill="#0f172a"/><text x="20" y="22" font-size="14" font-weight="bold" fill="#e2e8f0" font-family="Arial">Haber Duygu Analizi Sonuçları</text><text x="20" y="38" font-size="10" fill="#94a3b8" font-family="Arial">${veri.length} kayıt · ${new Date().toLocaleDateString("tr-TR")}</text><rect x="20" y="52" width="${tw}" height="${hh}" fill="#1d4ed8"/>${heads}${rows}</svg>`;
            const blob = new Blob([svg], { type: "image/svg+xml" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a"); a.href = url; a.download = `${dosyaAdi}.svg`; a.click(); URL.revokeObjectURL(url);
        }
    };
    return (
        <div style={{ position: "relative" }} onMouseEnter={() => setAcik(true)} onMouseLeave={() => setAcik(false)}>
            <button style={{ display: "flex", width: "100%", textAlign: "left", justifyContent: "space-between",
                padding: "10px 14px", border: "none", background: "none", cursor: "pointer",
                color: C.text, fontSize: 13, borderBottom: `1px solid ${C.border}` }}>
                📥 İndir <span style={{ color: C.muted }}>▶</span>
            </button>
            {acik && (
                <div style={{ position: "absolute", left: "100%", top: 0, background: C.panel,
                    border: `1px solid ${C.border}`, borderRadius: 8,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.4)", minWidth: 160, overflow: "hidden", zIndex: 101 }}>
                    {[{ l: "Excel (.xlsx)", f: "xlsx" }, { l: "CSV (.csv)", f: "csv" }, { l: "PDF (.pdf)", f: "pdf" }, { l: "SVG (.svg)", f: "svg" }].map(b => (
                        <button key={b.f} onClick={() => indir(b.f)}
                            style={{ display: "block", width: "100%", textAlign: "left", padding: "9px 14px",
                                border: "none", background: "none", cursor: "pointer", color: C.text, fontSize: 13,
                                borderBottom: `1px solid ${C.border}` }}>{b.l}</button>
                    ))}
                </div>
            )}
        </div>
    );
}

export default function HaberDuyguTarama() {
    const [mod, setMod] = useState("BIST");

    // --- Tarama durumu ---
    const [durum,      setDurum]      = useState(null);
    const [sonuc,      setSonuc]      = useState(null);     // { semboller: [...], genel_piyasa: {...}, tarih }
    const [yukleniyor, setYukleniyor] = useState(false);
    const [ilkYukleme, setIlkYukleme] = useState(true);
    const [aramaMetni, setAramaMetni] = useState("");
    const pollRef = useRef(null);

    // --- Seçim & işlemler ---
    const [secilenler,           setSecilenler]           = useState(new Set());
    const [islemMenuAcik,        setIslemMenuAcik]        = useState(false);

    // Sonuç Filtre Kartı: Ortalama Skor / Etiket
    const [filtreSkor,   setFiltreSkor]   = useState("Tümü"); // "Tümü" | "pozitif" | "negatif"
    const [filtreEtiket, setFiltreEtiket] = useState(new Set());

    // Alarm popup
    const [alarmPopup,        setAlarmPopup]        = useState(false);
    const [alarmHisseler,     setAlarmHisseler]     = useState([]);
    const [hedefFiyatlar,     setHedefFiyatlar]     = useState({});
    const [alarmMail,         setAlarmMail]         = useState(false);
    const [alarmBildirim,     setAlarmBildirim]     = useState(true);
    const [alarmKaydediliyor, setAlarmKaydediliyor] = useState(false);

    // Haber listesi popup (Pozitif/Negatif/Nötr sayısına tıklanınca açılır)
    const [haberListesiPopup,   setHaberListesiPopup]   = useState(null); // {symbol, etiket, baslik} | null
    const [haberListesi,        setHaberListesi]        = useState([]);
    const [haberListesiYukleniyor, setHaberListesiYukleniyor] = useState(false);

    // Haber detay popup (listedeki bir habere tıklanınca açılır)
    const [haberDetayPopup,     setHaberDetayPopup]     = useState(null); // haber objesi | null
    const [haberDetayYukleniyor, setHaberDetayYukleniyor] = useState(false);

    // --- Sayfa açılışında otomatik yükleme ---
    const [guncelHaberYok, setGuncelHaberYok] = useState(false);

    const sonuclariYukle = async (modParam, birlestir = false) => {
        try {
            const token = await getToken();
            if (!token) return;
            const res = await axios.get(`${API_URL}/scan/haber-duygu-sonuclar`, {
                params: { mod: modParam },
                headers: { Authorization: `Bearer ${token}` },
            });
            const yeni = res.data;
            if (!yeni?.semboller?.length && !yeni?.genel_piyasa) {
                setIlkYukleme(false);
                return;
            }
            if (birlestir) {
                setSonuc(onceki => {
                    if (!onceki) return yeni;
                    const eskiSymboller = onceki.semboller || [];
                    const yeniSymboller = yeni.semboller || [];
                    const eskiMap = Object.fromEntries(eskiSymboller.map(s => [s.symbol, s]));
                    const guncellenenler = yeniSymboller.filter(s =>
                        !eskiMap[s.symbol] || eskiMap[s.symbol].ortalama_skor !== s.ortalama_skor
                    );
                    const degismeyenler = eskiSymboller.filter(s =>
                        !yeniSymboller.find(y => y.symbol === s.symbol)
                    );
                    return { ...yeni, semboller: [...guncellenenler, ...degismeyenler] };
                });
            } else {
                setSonuc(yeni);
            }
        } catch (e) {
            console.log("Yükleme hatası:", e);
        } finally {
            setIlkYukleme(false);
        }
    };

    useEffect(() => {
        setAramaMetni("");
        setSecilenler(new Set());
        sonuclariYukle(mod);
    }, [mod]);

    // --- Tarama Başlat (manuel) ---
    const taramaBaslat = async () => {
        try {
            setYukleniyor(true);
            // Tablo SİLİNMEZ — mevcut kayıtlar yerinde durur
            const token = await getToken();
            await axios.post(`${API_URL}/scan/haber-duygu-tara`, {}, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success("Haber Duygu Analizi başlatıldı!");
            baslatPoll();
        } catch (e) {
            toast.error(e.response?.data?.detail || "Tarama başlatılamadı");
            setYukleniyor(false);
        }
    };

    const baslatPoll = () => {
        if (pollRef.current) clearInterval(pollRef.current);
        pollRef.current = setInterval(async () => {
            try {
                const token = await getToken();
                const res = await axios.get(`${API_URL}/scan/haber-duygu-durum`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setDurum(res.data);
                if (!res.data.calisiyor) {
                    clearInterval(pollRef.current);
                    setYukleniyor(false);
                    if (res.data.sonuc) {
                        const eslesen = res.data.sonuc.eslesen_sembol || 0;
                        if (eslesen === 0) {
                            setGuncelHaberYok(true);
                        } else {
                            toast.success(`Analiz tamamlandı! ${res.data.sonuc.islenen_haber} haber işlendi, ${eslesen} eşleşme bulundu.`);
                        }
                        sonuclariYukle(mod, true);
                    } else if (res.data.hata) {
                        toast.error("Analiz hatası: " + res.data.hata);
                    }
                }
            } catch {}
        }, 3000);
    };

    useEffect(() => () => { if (pollRef.current) clearInterval(pollRef.current); }, []);

    // --- Filtrelenmiş liste ---
    const semboller = sonuc?.semboller || [];
    const filtrelenmis = semboller.filter(s => {
        if (aramaMetni !== "" && !(s.symbol || "").toLowerCase().includes(aramaMetni.toLowerCase())) return false;
        if (filtreSkor === "pozitif" && !(s.ortalama_skor > 15)) return false;
        if (filtreSkor === "negatif" && !(s.ortalama_skor < -15)) return false;
        if (filtreEtiket.size > 0 && !filtreEtiket.has(s.etiket)) return false;
        return true;
    });
    const toggleFiltreEtiket = v => setFiltreEtiket(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });

    const rowKey = r => `${r.symbol}-${r.tarih}`;
    const tumSecili = filtrelenmis.length > 0 && filtrelenmis.every(r => secilenler.has(rowKey(r)));
    const toggleTum = () => { tumSecili ? setSecilenler(new Set()) : setSecilenler(new Set(filtrelenmis.map(rowKey))); };
    const toggleSec = (key) => { setSecilenler(prev => { const s = new Set(prev); s.has(key) ? s.delete(key) : s.add(key); return s; }); };
    const seciliSatirlar = () => filtrelenmis.filter(r => secilenler.has(rowKey(r)));

    const haberDuyguVerisi = () => {
        if (!filtrelenmis.length) return [];
        return filtrelenmis.map(s => ({
            Tarih: s.tarih, Sembol: s.symbol, "Haber Sayısı": s.haber_sayisi, Pozitif: s.pozitif_sayisi,
            Negatif: s.negatif_sayisi, Notr: s.notr_sayisi, "Ortalama Skor": s.ortalama_skor,
            "En Güçlü Skor": s.en_guclu_skor, Etiket: s.etiket,
        }));
    };

    // --- İşlemler: Doğruluk Analizi ---
    // --- İşlemler: Alarm ---
    const alarmAc = () => {
        if (secilenler.size === 0) { toast.error("Önce en az bir hisse seçin"); return; }
        const satirlar = seciliSatirlar();
        setAlarmHisseler(satirlar.map(r => ({ hisse: r.symbol, fiyat: null })));
        setHedefFiyatlar({}); setAlarmMail(false); setAlarmBildirim(true);
        setAlarmPopup(true); setIslemMenuAcik(false);
    };

    const alarmKaydet = async () => {
        const eksik = alarmHisseler.find(h => !hedefFiyatlar[h.hisse] || isNaN(parseFloat(hedefFiyatlar[h.hisse])));
        if (eksik) { toast.error(`${eksik.hisse} için hedef fiyat girin`); return; }
        setAlarmKaydediliyor(true);
        try {
            const { data: { session } } = await supabase.auth.getSession();
            for (const h of alarmHisseler) {
                const hedef = parseFloat(hedefFiyatlar[h.hisse]);
                const { error } = await supabase.from("alerts").insert({
                    piyasa: mod, sembol: h.hisse, para_birimi: mod === "BIST" ? "TL" : "USD",
                    fiyat: null, hedef_fiyat: hedef, potansiyel: null,
                    bildirim_mail: alarmMail, bildirim_popup: alarmBildirim, user_id: session.user.id,
                });
                if (error) throw error;
            }
            toast.success(`${alarmHisseler.length} alarm eklendi!`);
            setAlarmPopup(false); setAlarmHisseler([]);
        } catch (e) { toast.error("Alarm kaydedilemedi: " + e.message); }
        finally { setAlarmKaydediliyor(false); }
    };

    const genel = sonuc?.genel_piyasa;

    // --- Haber listesi popup'ı aç (Pozitif/Negatif/Nötr sayısına tıklanınca) ---
    const haberListesiAc = async (symbol, etiket, baslik, tarihStr = null) => {
        setHaberListesiPopup({ symbol, etiket, baslik });
        setHaberListesi([]);
        setHaberListesiYukleniyor(true);
        try {
            const token = await getToken();
            const res = await axios.get(`${API_URL}/scan/haber-duygu-haberler`, {
                params: { etiket, symbol: symbol || undefined, mod, tarih: tarihStr || undefined },
                headers: { Authorization: `Bearer ${token}` },
            });
            setHaberListesi(res.data || []);
        } catch (e) {
            toast.error("Haberler yüklenemedi: " + (e.response?.data?.detail || e.message));
        } finally {
            setHaberListesiYukleniyor(false);
        }
    };

    // --- Haber detay popup'ı aç (listedeki bir habere tıklanınca) ---
    const haberDetayAc = async (haberId) => {
        setHaberDetayPopup({ haber_id: haberId });
        setHaberDetayYukleniyor(true);
        try {
            const token = await getToken();
            const res = await axios.get(`${API_URL}/scan/haber-duygu-haber-detay`, {
                params: { haber_id: haberId },
                headers: { Authorization: `Bearer ${token}` },
            });
            setHaberDetayPopup(res.data);
        } catch (e) {
            toast.error("Haber detayı yüklenemedi: " + (e.response?.data?.detail || e.message));
            setHaberDetayPopup(null);
        } finally {
            setHaberDetayYukleniyor(false);
        }
    };

    return (
        <div style={{ background: C.bg, minHeight: "100vh", padding: "24px", fontFamily: "system-ui, sans-serif" }}>

            {/* Başlık */}
            <div style={{ marginBottom: 24 }}>
                <h1 style={{ color: C.text, fontSize: 22, fontWeight: 800, margin: 0 }}>
                    📰 Haber Duygu Analizi
                </h1>
                <p style={{ color: C.muted, fontSize: 13, margin: "6px 0 0", maxWidth: 760, lineHeight: 1.6 }}>
                    RSS kaynaklarından toplanan haberleri BIST100/30 ve Kripto sembolleriyle eşleştirip
                    kural-tabanlı sözlük + Gemini AI teyidiyle duygu skoru hesaplar. Her gün otomatik
                    güncellenir; manuel olarak da yeniden taratabilirsiniz.
                </p>
            </div>

            {/* Kontrol Paneli */}
            <div style={{
                background: C.panel, border: `1px solid ${C.border}`,
                borderRadius: 12, padding: "20px 24px", marginBottom: 16,
                display: "flex", alignItems: "flex-end", gap: 16, flexWrap: "wrap",
            }}>
                {/* Piyasa */}
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>PİYASA</label>
                    <select value={mod} onChange={e => setMod(e.target.value)} disabled={yukleniyor}
                        style={{ padding: "8px 12px", borderRadius: 8, border: `1px solid ${C.border}`,
                            background: "#0f172a", color: C.text, fontSize: 13, fontWeight: 600,
                            cursor: yukleniyor ? "not-allowed" : "pointer", outline: "none", minWidth: 120 }}>
                        <option value="BIST">BIST</option>
                        <option value="Kripto">Kripto</option>
                    </select>
                </div>

                {/* Arama */}
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>SEMBOL ARA</label>
                    <input value={aramaMetni} onChange={e => setAramaMetni(e.target.value)} placeholder="örn. THYAO"
                        style={{ padding: "8px 12px", borderRadius: 8, border: `1px solid ${C.border}`,
                            background: "#0f172a", color: C.text, fontSize: 13, outline: "none", minWidth: 140 }} />
                </div>

                {/* Tarama butonu */}
                <button onClick={taramaBaslat} disabled={yukleniyor} style={{
                    padding: "10px 28px", borderRadius: 8,
                    background: yukleniyor ? "#334155" : C.accent,
                    border: "none", color: "white", fontWeight: 700, fontSize: 14,
                    cursor: yukleniyor ? "not-allowed" : "pointer", alignSelf: "flex-end",
                }}>
                    {yukleniyor ? "⏳ Taranıyor..." : "🚀 Yeniden Tara"}
                </button>

                {/* İlerleme */}
                {yukleniyor && durum && (
                    <div style={{ flexBasis: "100%", marginTop: 4 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: C.muted, marginBottom: 5 }}>
                            <span>{durum.mesaj}</span>
                            <span style={{ color: C.accent, fontWeight: 700 }}>{durum.ilerleme || 0}%</span>
                        </div>
                        <div style={{ height: 6, background: C.border, borderRadius: 3, overflow: "hidden" }}>
                            <div style={{ height: "100%", borderRadius: 3,
                                background: `linear-gradient(90deg, ${C.accent}, #60a5fa)`,
                                width: `${durum.ilerleme || 0}%`, transition: "width 0.4s ease" }} />
                        </div>
                        {durum.tahmini_sure != null && durum.tahmini_sure > 0 && (
                            <div style={{ marginTop: 5, fontSize: 11, color: C.gold, fontWeight: 600 }}>
                                ⏱ Tahmini kalan: {formatSure(durum.tahmini_sure)}
                                {durum.tamamlanan > 0 && durum.toplam > 0 && (
                                    <span style={{ color: C.muted, fontWeight: 400, marginLeft: 8 }}>
                                        ({durum.tamamlanan}/{durum.toplam})
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Genel Piyasa Skoru Kartı */}
            {genel && (
                <div style={{ background: C.panel, border: `1px solid ${C.border}`, borderRadius: 12,
                    padding: "18px 24px", marginBottom: 16, display: "flex", alignItems: "center", gap: 24, flexWrap: "wrap" }}>
                    <div>
                        <div style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em", marginBottom: 4, display: "flex", alignItems: "center" }}>
                            GENEL PİYASA HABER SKORU<BilgiIkonu alan="Genel Piyasa Haber Skoru" />
                        </div>
                        <div style={{ fontSize: 26, fontWeight: 800, color: etiketRenk(genel.etiket) }}>
                            {genel.etiket} ({genel.ortalama_skor > 0 ? "+" : ""}{genel.ortalama_skor})
                        </div>
                    </div>
                    <div style={{ display: "flex", gap: 20, fontSize: 13, color: C.muted }}>
                        <span>📰 {genel.haber_sayisi} haber</span>
                        <span
                            onClick={() => haberListesiAc(null, "Pozitif", "Genel Piyasa — Pozitif Haberler (Son 7 Gün)", genel.tarih || null)}
                            style={{ color: C.bullish, cursor: "pointer", textDecoration: "underline", textUnderlineOffset: 3 }}>
                            ▲ {genel.pozitif_sayisi} pozitif
                        </span>
                        <span
                            onClick={() => haberListesiAc(null, "Negatif", "Genel Piyasa — Negatif Haberler (Son 7 Gün)", genel.tarih || null)}
                            style={{ color: C.bearish, cursor: "pointer", textDecoration: "underline", textUnderlineOffset: 3 }}>
                            ▼ {genel.negatif_sayisi} negatif
                        </span>
                        <span
                            onClick={() => haberListesiAc(null, "Nötr", "Genel Piyasa — Nötr Haberler (Son 7 Gün)", genel.tarih || null)}
                            style={{ cursor: "pointer", textDecoration: "underline", textUnderlineOffset: 3 }}>
                            ● {genel.notr_sayisi} nötr
                        </span>
                    </div>
                    {(sonuc?.aralik || sonuc?.tarih) && (
                        <div style={{ marginLeft: "auto", fontSize: 12, color: C.muted }}>
                            {sonuc?.aralik || sonuc?.tarih}
                        </div>
                    )}
                </div>
            )}

            {/* Filtre Kartı: İşlemler (en solda) + Ortalama Skor + Etiket */}
            {semboller.length > 0 && (
                <div style={{ background: C.panel, border: `1px solid ${C.border}`, borderRadius: 12,
                    padding: "12px 20px", marginBottom: 16, display: "flex", gap: 20, flexWrap: "wrap", alignItems: "center" }}>

                    {/* İşlemler menüsü — en sol */}
                    <div style={{ position: "relative" }}>
                        <button onClick={() => setIslemMenuAcik(v => !v)} style={{
                            padding: "6px 16px", borderRadius: 8, border: `1px solid ${C.border}`,
                            background: "#0f172a", color: C.text, cursor: "pointer", fontSize: 13, fontWeight: 600,
                        }}>
                            İşlemler ▾ {secilenler.size > 0 && `(${secilenler.size})`}
                        </button>
                        {islemMenuAcik && (
                            <div style={{
                                position: "absolute", top: "calc(100% + 4px)", left: 0,
                                background: C.panel, border: `1px solid ${C.border}`, borderRadius: 10,
                                boxShadow: "0 8px 24px rgba(0,0,0,0.4)", zIndex: 100, minWidth: 220, overflow: "visible",
                            }}>
                                {[
                                    { label: "⏰ Alarm Ekle", aktif: true, fn: alarmAc },
                                ].map(item => (
                                    <button key={item.label} onClick={item.aktif ? item.fn : undefined} disabled={!item.aktif}
                                        style={{ display: "block", width: "100%", textAlign: "left", padding: "10px 14px",
                                            border: "none", background: "none", fontSize: 13, borderBottom: `1px solid ${C.border}`,
                                            cursor: item.aktif ? "pointer" : "default", color: item.aktif ? C.text : C.muted }}>
                                        {item.label}
                                    </button>
                                ))}
                                <IndirMenusu veriler={haberDuyguVerisi} setIslemMenuAcik={setIslemMenuAcik} />
                            </div>
                        )}
                    </div>

                    <div style={{ width: 1, height: 20, background: C.border }} />

                    {/* Ortalama Skor filtresi */}
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: C.muted, letterSpacing: "0.05em", display: "flex", alignItems: "center" }}>
                            ORTALAMA SKOR<BilgiIkonu alan="Ortalama Skor" />
                        </span>
                        {[
                            { v: "Tümü", l: "Tümü", renk: C.muted },
                            { v: "pozitif", l: "▲ Pozitif (>15)", renk: C.bullish },
                            { v: "negatif", l: "▼ Negatif (<-15)", renk: C.bearish },
                        ].map(opt => {
                            const aktif = filtreSkor === opt.v;
                            return (
                                <button key={opt.v} onClick={() => setFiltreSkor(opt.v)} style={{
                                    padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                    fontWeight: aktif ? 700 : 400,
                                    border: `2px solid ${aktif ? opt.renk : C.border}`,
                                    background: aktif ? opt.renk + "22" : "transparent",
                                    color: aktif ? opt.renk : C.muted,
                                }}>{opt.l}</button>
                            );
                        })}
                    </div>

                    <div style={{ width: 1, height: 20, background: C.border }} />

                    {/* Etiket filtresi */}
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: C.muted, letterSpacing: "0.05em", display: "flex", alignItems: "center" }}>
                            ETİKET<BilgiIkonu alan="Etiket" />
                        </span>
                        {["Pozitif", "Negatif", "Nötr"].map(v => {
                            const aktif = filtreEtiket.has(v);
                            const renk = etiketRenk(v);
                            return (
                                <button key={v} onClick={() => toggleFiltreEtiket(v)} style={{
                                    padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                    fontWeight: aktif ? 700 : 400,
                                    border: `2px solid ${aktif ? renk : C.border}`,
                                    background: aktif ? renk + "22" : "transparent",
                                    color: aktif ? renk : C.muted,
                                }}>{v}</button>
                            );
                        })}
                    </div>

                    <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 10 }}>
                        <span style={{ fontSize: 12, color: C.muted }}>
                            <strong style={{ color: C.text }}>{filtrelenmis.length}</strong> / {semboller.length} sonuç
                        </span>
                        {(filtreSkor !== "Tümü" || filtreEtiket.size > 0) && (
                            <button onClick={() => { setFiltreSkor("Tümü"); setFiltreEtiket(new Set()); }}
                                style={{ padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                    border: `1px solid ${C.bearish}66`, background: C.bearish + "11", color: C.bearish }}>
                                ✕ Temizle
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Tablo */}
            {filtrelenmis.length > 0 && (
                <div style={{ overflowX: "auto", borderRadius: 12, border: `1px solid ${C.border}` }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, background: C.panel }}>
                        <thead>
                            <tr style={{ background: "#1e3a5f" }}>
                                <th style={{ padding: "10px 12px", width: 36 }}>
                                    <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                                </th>
                                {["Tarih", "Sembol", "Haber Sayısı", "Pozitif", "Negatif", "Nötr", "Ortalama Skor", "En Güçlü Skor", "Etiket"].map(h => (
                                    <th key={h} style={{ padding: "10px 12px", color: "white", textAlign: "left",
                                        whiteSpace: "nowrap", fontSize: 12 }}>
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {h}{["Ortalama Skor", "En Güçlü Skor", "Etiket"].includes(h) && <BilgiIkonu alan={h} />}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filtrelenmis.map((r, i) => (
                                <tr key={`${r.symbol}-${r.tarih}`} style={{ background: i % 2 === 0 ? C.panel : "#16213a",
                                    borderBottom: `1px solid ${C.border}` }}>
                                    <td style={{ padding: "8px 12px" }}>
                                        <input type="checkbox" checked={secilenler.has(`${r.symbol}-${r.tarih}`)}
                                            onChange={() => toggleSec(`${r.symbol}-${r.tarih}`)} />
                                    </td>
                                    <td style={{ padding: "8px 12px", color: C.muted, fontSize: 12, whiteSpace: "nowrap" }}>
                                        {r.tarih}
                                    </td>
                                    <td style={{ padding: "8px 12px", fontWeight: 700, color: C.text }}>{r.symbol}</td>
                                    <td style={{ padding: "8px 12px", color: C.muted }}>{r.haber_sayisi}</td>
                                    <td style={{ padding: "8px 12px", color: C.bullish, fontWeight: 600,
                                        cursor: "pointer", textDecoration: "underline", textUnderlineOffset: 3 }}
                                        onClick={() => haberListesiAc(r.symbol, "Pozitif", `${r.symbol} ${r.tarih} — Pozitif Haberler`, r.tarih)}>
                                        {r.pozitif_sayisi}
                                    </td>
                                    <td style={{ padding: "8px 12px", color: C.bearish, fontWeight: 600,
                                        cursor: "pointer", textDecoration: "underline", textUnderlineOffset: 3 }}
                                        onClick={() => haberListesiAc(r.symbol, "Negatif", `${r.symbol} ${r.tarih} — Negatif Haberler`, r.tarih)}>
                                        {r.negatif_sayisi}
                                    </td>
                                    <td style={{ padding: "8px 12px", color: C.muted,
                                        cursor: "pointer", textDecoration: "underline", textUnderlineOffset: 3 }}
                                        onClick={() => haberListesiAc(r.symbol, "Nötr", `${r.symbol} ${r.tarih} — Nötr Haberler`, r.tarih)}>
                                        {r.notr_sayisi}
                                    </td>
                                    <td style={{ padding: "8px 12px" }}><SkorCubugu skor={r.ortalama_skor} /></td>
                                    <td style={{ padding: "8px 12px", color: etiketRenk(r.etiket), fontWeight: 600 }}>
                                        {typeof r.en_guclu_skor === "number" ? (r.en_guclu_skor > 0 ? "+" : "") + r.en_guclu_skor : "—"}
                                    </td>
                                    <td style={{ padding: "8px 12px", color: etiketRenk(r.etiket), fontWeight: 700 }}>{r.etiket}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {!ilkYukleme && !yukleniyor && semboller.length > 0 && filtrelenmis.length === 0 && (
                <div style={{ textAlign: "center", padding: "2rem", color: C.muted }}>
                    "{aramaMetni}" için eşleşen sembol bulunamadı.
                </div>
            )}

            {!ilkYukleme && !yukleniyor && semboller.length === 0 && !genel && (
                <div style={{ textAlign: "center", padding: "3rem", color: C.muted }}>
                    Son 7 günde {mod} piyasasına ait haber duygu verisi bulunamadı. "🚀 Yeniden Tara" ile başlatabilirsiniz.
                </div>
            )}

            {ilkYukleme && (
                <div style={{ textAlign: "center", padding: "3rem", color: C.muted }}>
                    Yükleniyor...
                </div>
            )}

            {/* --- Güncel Haber Yok Popup --- */}
            {guncelHaberYok && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex",
                    alignItems: "center", justifyContent: "center", zIndex: 1200 }}
                    onClick={() => setGuncelHaberYok(false)}>
                    <div style={{ background: C.panel, borderRadius: 12, padding: "1.75rem 2rem", width: 380,
                        border: `1px solid ${C.border}`, textAlign: "center" }}
                        onClick={e => e.stopPropagation()}>
                        <div style={{ fontSize: 32, marginBottom: 12 }}>📭</div>
                        <div style={{ fontSize: 15, fontWeight: 700, color: C.text, marginBottom: 8 }}>
                            Güncel haber bulunamadı
                        </div>
                        <div style={{ fontSize: 13, color: C.muted, lineHeight: 1.6, marginBottom: 20 }}>
                            {mod} piyasasına ait güncel haber bulunamadı.
                            <br />Mevcut kayıtlar listede gösterilmeye devam ediyor.
                        </div>
                        <button onClick={() => setGuncelHaberYok(false)}
                            style={{ padding: "8px 24px", borderRadius: 8, border: "none",
                                background: C.accent, color: "white", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                            Tamam
                        </button>
                    </div>
                </div>
            )}

            {/* --- Alarm Popup --- */}
            {alarmPopup && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex",
                    alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
                    <div style={{ background: C.panel, borderRadius: 12, padding: "1.5rem", width: 420,
                        maxHeight: "80vh", overflowY: "auto", border: `1px solid ${C.border}` }}>
                        <h3 style={{ margin: "0 0 0.75rem", fontSize: 16, color: C.text }}>⏰ Alarm Ekle</h3>
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            {alarmHisseler.map(h => (
                                <div key={h.hisse} style={{ background: "#0f172a", borderRadius: 8, padding: "10px 12px",
                                    border: `1px solid ${C.border}` }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                                        <strong style={{ fontSize: 14, color: C.text }}>{h.hisse}</strong>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <span style={{ color: C.muted, fontSize: 12, minWidth: 80 }}>Hedef Fiyat:</span>
                                        <input type="number" value={hedefFiyatlar[h.hisse] || ""}
                                            onChange={e => setHedefFiyatlar(prev => ({ ...prev, [h.hisse]: e.target.value }))}
                                            style={{ flex: 1, padding: "4px 8px", borderRadius: 6, border: `1px solid ${C.border}`,
                                                background: "#0a0f1e", color: C.text, fontSize: 13, textAlign: "right" }}
                                            placeholder="0.00" />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div style={{ marginTop: 12 }}>
                            <div style={{ color: C.muted, marginBottom: 6, fontSize: 12 }}>Bildirim Tercihi:</div>
                            <div style={{ display: "flex", gap: 16 }}>
                                {[["Mail", alarmMail, setAlarmMail], ["Pop-up", alarmBildirim, setAlarmBildirim]].map(([ad, val, setter]) => (
                                    <label key={ad} style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer",
                                        fontSize: 13, color: C.text }}>
                                        <input type="checkbox" checked={val} onChange={e => setter(e.target.checked)} /> {ad}
                                    </label>
                                ))}
                            </div>
                        </div>
                        <div style={{ display: "flex", gap: 8, marginTop: "1.25rem", justifyContent: "flex-end" }}>
                            <button onClick={() => { setAlarmPopup(false); setAlarmHisseler([]); }}
                                style={{ padding: "8px 18px", borderRadius: 8, border: `1px solid ${C.border}`,
                                    background: "#0f172a", cursor: "pointer", fontSize: 13, color: C.muted }}>Vazgeç</button>
                            <button onClick={alarmKaydet} disabled={alarmKaydediliyor}
                                style={{ padding: "8px 20px", borderRadius: 8, border: "none",
                                    background: alarmKaydediliyor ? "#334155" : C.accent, color: "white",
                                    fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                                {alarmKaydediliyor ? "Kaydediliyor..." : "Kaydet"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* --- Haber Listesi Popup (Pozitif/Negatif/Nötr sayısına tıklanınca) --- */}
            {haberListesiPopup && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex",
                    alignItems: "center", justifyContent: "center", zIndex: 1000 }}
                    onClick={() => setHaberListesiPopup(null)}>
                    <div style={{ background: C.panel, borderRadius: 12, padding: "1.5rem", width: 560,
                        maxHeight: "80vh", overflowY: "auto", border: `1px solid ${C.border}` }}
                        onClick={e => e.stopPropagation()}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
                            <div>
                                <div style={{ fontSize: 16, fontWeight: 700, color: C.text }}>
                                    {haberListesiPopup.baslik}
                                </div>
                                <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>
                                    {haberListesi.length} haber
                                </div>
                            </div>
                            <button onClick={() => setHaberListesiPopup(null)}
                                style={{ background: "none", border: "none", color: C.muted, fontSize: 20, cursor: "pointer" }}>✕</button>
                        </div>

                        {haberListesiYukleniyor && (
                            <div style={{ textAlign: "center", padding: "2rem", color: C.muted }}>Yükleniyor...</div>
                        )}

                        {!haberListesiYukleniyor && haberListesi.length === 0 && (
                            <div style={{ textAlign: "center", padding: "2rem", color: C.muted }}>Bu kategoride haber bulunamadı.</div>
                        )}

                        {!haberListesiYukleniyor && haberListesi.length > 0 && (
                            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                {haberListesi.map(h => (
                                    <button key={h.haber_id} onClick={() => haberDetayAc(h.haber_id)}
                                        style={{ display: "block", textAlign: "left", background: "#0f172a",
                                            border: `1px solid ${C.border}`, borderRadius: 8, padding: "10px 14px",
                                            cursor: "pointer", width: "100%" }}>
                                        <div style={{ fontSize: 13, color: C.text, fontWeight: 600, lineHeight: 1.4 }}>
                                            {h.baslik}
                                        </div>
                                        <div style={{ display: "flex", gap: 12, marginTop: 6, fontSize: 11, color: C.muted, alignItems: "center" }}>
                                            <span>{h.kaynak}</span>
                                            <span>{h.cekilme_zamani ? new Date(h.cekilme_zamani).toLocaleString("tr-TR") : ""}</span>
                                            <span style={{ marginLeft: "auto", color: etiketRenk(h.nihai_etiket), fontWeight: 700 }}>
                                                {h.nihai_skor > 0 ? "+" : ""}{h.nihai_skor}
                                            </span>
                                            {h.gemini_calisti && (
                                                <span style={{ color: C.accent, fontSize: 10, fontWeight: 600 }}>✨ Gemini</span>
                                            )}
                                        </div>
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* --- Haber Detay Popup (listedeki bir habere tıklanınca) --- */}
            {haberDetayPopup && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex",
                    alignItems: "center", justifyContent: "center", zIndex: 1100 }}
                    onClick={() => setHaberDetayPopup(null)}>
                    <div style={{ background: C.panel, borderRadius: 12, padding: "1.5rem", width: 480,
                        maxHeight: "80vh", overflowY: "auto", border: `1px solid ${C.border}` }}
                        onClick={e => e.stopPropagation()}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1rem" }}>
                            <div style={{ fontSize: 16, fontWeight: 700, color: C.text, lineHeight: 1.4, paddingRight: 12 }}>
                                {haberDetayYukleniyor ? "Yükleniyor..." : (haberDetayPopup.baslik || "")}
                            </div>
                            <button onClick={() => setHaberDetayPopup(null)}
                                style={{ background: "none", border: "none", color: C.muted, fontSize: 20, cursor: "pointer", flexShrink: 0 }}>✕</button>
                        </div>

                        {!haberDetayYukleniyor && haberDetayPopup.kaynak && (
                            <>
                                <div style={{ display: "flex", gap: 16, fontSize: 12, color: C.muted, marginBottom: "1rem", flexWrap: "wrap" }}>
                                    <span>📡 {haberDetayPopup.kaynak}</span>
                                    <span>🗂 {haberDetayPopup.kategori}</span>
                                    <span>🕒 {haberDetayPopup.cekilme_zamani ? new Date(haberDetayPopup.cekilme_zamani).toLocaleString("tr-TR") : "—"}</span>
                                </div>

                                {(haberDetayPopup.skorlar || []).map((s, i) => (
                                    <div key={i} style={{ background: "#0f172a", border: `1px solid ${C.border}`, borderRadius: 8,
                                        padding: "12px 14px", marginBottom: 10 }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                                            <strong style={{ color: C.text, fontSize: 14 }}>
                                                {s.symbol || "Genel Piyasa"}
                                            </strong>
                                            <span style={{ color: etiketRenk(s.nihai_etiket), fontWeight: 700, fontSize: 14 }}>
                                                {s.nihai_etiket} ({s.nihai_skor > 0 ? "+" : ""}{s.nihai_skor})
                                            </span>
                                        </div>
                                        <div style={{ fontSize: 11, color: C.muted, marginBottom: 4 }}>
                                            Kural-tabanlı skor: {s.kural_skor}
                                            {s.gemini_calisti && ` · Gemini güven: %${s.gemini_guven}`}
                                        </div>
                                        {s.gemini_calisti && s.gemini_gerekce && (
                                            <div style={{ fontSize: 12, color: C.text, marginTop: 6, lineHeight: 1.5,
                                                borderTop: `1px solid ${C.border}`, paddingTop: 6 }}>
                                                ✨ <em>{s.gemini_gerekce}</em>
                                            </div>
                                        )}
                                    </div>
                                ))}

                                {haberDetayPopup.link && (
                                    <a href={haberDetayPopup.link} target="_blank" rel="noopener noreferrer"
                                        style={{ display: "block", textAlign: "center", marginTop: 12, padding: "10px",
                                            borderRadius: 8, background: C.accent, color: "white", fontSize: 13,
                                            fontWeight: 600, textDecoration: "none" }}>
                                        🔗 Orijinal Habere Git
                                    </a>
                                )}
                            </>
                        )}
                    </div>
                </div>
            )}

            {islemMenuAcik && <div style={{ position: "fixed", inset: 0, zIndex: 99 }} onClick={() => setIslemMenuAcik(false)} />}
        </div>
    );
}
